import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import {
  approveSchedule,
  unapproveSchedule,
} from "../../../store/actions/scheduleAction";
import { parseVariables } from "../../../helpers/localize";
import parser from "html-react-parser";
import { showSanitizedInput } from "../../../helpers/inputProcessing";

const ApproveScheduleConfirmation = ({
  schedule,
  open,
  handleClickClose,
  callback,
}) => {
  const dispatch = useDispatch();

  const { t } = useTranslation("schedule");
  const { t: tCommon } = useTranslation();

  const [loading, setLoading] = useState(false);

  if (!schedule) {
    return null;
  }

  const successCallback = async () => {
    if (callback) await callback();
    setLoading(false);
    handleClickClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    dispatch(
      schedule.isApproved
        ? unapproveSchedule(schedule.id, successCallback)
        : approveSchedule(schedule.id, successCallback)
    );
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={() => {
        if (!loading) handleClickClose();
      }}
    >
      <DialogContent>
        <DialogContentText
          sx={{
            textAlign: "center",
            mb: 2,
          }}
        >
          {schedule.isApproved
            ? parser(
                parseVariables(t("item.suspendConfirmationText"), {
                  name: showSanitizedInput(schedule.name),
                })
              )
            : parser(
                parseVariables(t("item.approveConfirmationText"), {
                  name: showSanitizedInput(schedule.name),
                })
              )}
        </DialogContentText>

        <Box>
          <Alert severity="warning" variant="outlined">
            <strong>
              {schedule.isApproved
                ? t("item.suspendWarningHint")
                : t("item.approveWarningHint")}
            </strong>
          </Alert>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          color="error"
          variant="outlined"
          fullWidth
          startIcon={<ClearIcon />}
          onClick={() => {
            if (!loading) handleClickClose();
          }}
          disabled={loading}
        >
          {tCommon("cancelBtn")}
        </Button>

        <Button
          color={schedule.isApproved ? "warning" : "primary"}
          variant="contained"
          fullWidth
          startIcon={!loading && <DoneIcon />}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : tCommon("continueBtn")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveScheduleConfirmation;
